// extracted by mini-css-extract-plugin
export default {"page":"pageLayout_page__8tWpn"};